import { API_URL } from "../../../context/appContext";
export default async function loginUser(data) {
    return fetch(`${API_URL}/api/login`, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        }, body: JSON.stringify(data)
    })
        .then(res => res.json())
        .then(res => res)
        .catch(err => err)
}
